import ApiService from "./ApiService";
import { API_BASE_URL } from "redux/constants";

// The SysConfig/* functions below are migrated from raw fetch() (no
// Authorization header at all) to ApiService/BaseService as part of
// increment 4 -- this is why the Users and Roles grids stopped loading once
// PC_API started actually enforcing auth on every endpoint. The Account/*
// and Merchant/* functions in this file are left untouched: Account/*
// duplicates real endpoints implemented elsewhere (and is [AllowAnonymous]
// on the backend regardless) and Merchant/* targets backend routes that
// don't exist at all in this codebase (no MerchantController) -- migrating
// their transport wouldn't fix anything, they were already broken before
// this session's changes.

let localStorageObject = localStorage.getItem("User_Full_Info");
let userFulInfo = JSON.parse(localStorageObject);


// Migrated -- unlike Login/ForgetPassword/ValidateOTP below, Account/UpdateAuth
// is a post-login, protected endpoint (the MFA-settings screen, views/MfaModes/Mfa.js),
// not [AllowAnonymous] on the backend, so it needs the auth header ApiService/
// BaseService attaches automatically.
export async function UpdateAuth(id, AuthType) {
  const response = await ApiService.fetchData({
    url: "Account/UpdateAuth",
    method: "post",
    params: { Id: id, AuthType },
  });
  return response.data;
}

export async function verifyOtpApi (userName,otp) {

  const response = await fetch(API_BASE_URL +'Account/ValidateOTP', {
      method: "POST",
      body: JSON.stringify({
        userName: userName,
        otp: otp
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      }
  });
  var data = await response.json();

  return data;
}
// captchaToken: the Turnstile answer from the sign-in page (empty when the check is switched off).
export async function AccountSignIn (userName,password,captchaToken) {
  ;
  const response = await fetch(API_BASE_URL +'Account/Login', {
      method: "POST",
      body: JSON.stringify({
        userName: userName,
        password: password
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "X-Captcha-Token": captchaToken || ""
      }
  });
  var data = await response.json();

  return data;
}
export async function updateRole(object) {
  const response = await ApiService.fetchData({
    url: "SysConfig/UpdateRole",
    method: "post",
    data: object,
  });
  return response.data;
}

export async function apiDeleteRoles(id) {
  const response = await ApiService.fetchData({
    url: "SysConfig/DeleteRole",
    method: "post",
    params: { Id: id },
  });
  return response.data;
}
export async function apiDeleteUsers(id) {
  const response = await ApiService.fetchData({
    url: "SysConfig/DeleteUser",
    method: "post",
    params: { Id: id },
  });
  return response.data;
}

// ADDED (MFA): administrator resets a user's sign-in verification to the
// default (a code emailed to the user). Admin-only on the API side.
export async function ResetUserMfa(userId) {
  const response = await ApiService.fetchData({
    url: "SysConfig/ResetUserMfa",
    method: "post",
    params: { userId },
  });
  return response.data;
}

// ADDED: administrator-only check of the e-mail settings. Sends one short test message and returns, step
// by step, what worked and what stopped (settings, templates, connect, sign in, send). No secrets in it.
export async function apiSendTestEmail(to) {
  const response = await ApiService.fetchData({
    url: "SysConfig/SendTestEmail",
    method: "post",
    params: to ? { to } : {},
  });
  return response.data;
}

// FormData turns a missing value into the words "null" or "undefined", and the server then stored those
// words (a vendor with no last name was welcomed as "Solution Click null"). A missing value is sent as
// an empty text instead.
const formText = (value) => (value === null || value === undefined ? "" : value);

export async function UpdateUser(object, id) {
  let formData = new FormData();
  formData.append("Id", id);
  formData.append("FirstName", formText(object.firstName));
  formData.append("LastName", formText(object.lastName));
  formData.append("Gender", formText(object.gender));
  // The picture is sent only when a new file was chosen.
  if (typeof Blob !== "undefined" && object.image instanceof Blob) formData.append("Image", object.image);
  formData.append("Email", formText(object.email));
  formData.append("PhoneNumber", formText(object.phoneNumber));
  formData.append("RoleId", formText(object.roleId));
  if (object.password) formData.append("Password", object.password);

  const response = await ApiService.fetchData({
    url: "SysConfig/UpdateUser",
    method: "post",
    data: formData,
  });
  return response.data;
}

export async function AddUser(object) {
  let formData = new FormData();
  formData.append("FirstName", formText(object.firstName));
  formData.append("LastName", formText(object.lastName));
  formData.append("Gender", formText(object.gender));
  if (typeof Blob !== "undefined" && object.image instanceof Blob) formData.append("Image", object.image);
  formData.append("Email", formText(object.email));
  formData.append("PhoneNumber", formText(object.phoneNumber));
  formData.append("RoleId", formText(object.roleId));
  // Password is no longer sent: the API generates it and emails it to the user.
  //   formData.append('PlayersId', playerIds);

  const response = await ApiService.fetchData({
    url: "SysConfig/AddUser",
    method: "post",
    data: formData,
  });
  return response.data;
}

export async function GetRoleById(id) {
  const response = await ApiService.fetchData({
    url: "SysConfig/GetRoleById",
    method: "get",
    params: { Id: id },
  });
  return response.data;
}
export async function GetUsersById(id) {
  const response = await ApiService.fetchData({
    url: "SysConfig/GetUserById",
    method: "get",
    params: { Id: id },
  });
  return response.data;
}

// Added alongside the React Query conversion of managerGroup/components/
// UsersAgainstRole.js, which called this same route with a raw fetch() (no
// Authorization header) -- same fix as the rest of this file.
export async function apiGetUsersByRoleId(roleId) {
  const response = await ApiService.fetchData({
    url: "SysConfig/GetUsersByRoleId",
    method: "get",
    params: { roleId },
  });
  return response.data;
}

export async function apiGetAllUsers() {
  const response = await ApiService.fetchData({
    url: "SysConfig/GetAllUsers",
    method: "get",
  });
  return response.data;
}
export const EnableDisableUser = (id, IsEnable) => {
  return ApiService.fetchData({
    url: "SysConfig/EnableDisableUser",
    method: "post",
    params: { UserId: id, IsEnable },
  });
}

export async function apiGetAllRoles() {
  const response = await ApiService.fetchData({
    url: "SysConfig/GetAllRoles",
    method: "get",
  });
  return response.data;
}

export async function addRole(object) {
  const response = await ApiService.fetchData({
    url: "SysConfig/AddRoles",
    method: "post",
    data: {
      isAdmin: object.isAdmin,
      name: object.name,
      isSystemRole: object.isSystemRole,
    },
  });
  return response.data;
}
